import { useTranslation } from 'react-i18next';

interface TimeOffFallbackTooltipProps {
  isApproved: boolean;
  hoursLabel: string;
}

/**
 * Minimal tooltip shown for a segment that has no matching enriched request
 * (e.g. before the backend supplies `timeOffRequests`). Falls back to the
 * status word + hours; the rich `TimeOffTooltipContent` is used otherwise.
 */
export function TimeOffFallbackTooltip({ isApproved, hoursLabel }: TimeOffFallbackTooltipProps) {
  const { t } = useTranslation('authenticated.timeTracking');
  return (
    <div className="flex flex-col gap-0.5 text-left">
      <span className="text-[13px] font-semibold text-foreground">
        {isApproved ? t('weekView.timeOff.statusApproved') : t('weekView.timeOff.statusRequested')}
      </span>
      <span className="text-[12px] text-muted-foreground">
        {t('weekView.timeOff.tooltipHours', { hours: hoursLabel })}
      </span>
    </div>
  );
}
